import { compareAsc, parse, isAfter, isEqual } from 'date-fns';

function getCompareDate(): Date {
  var today = new Date();
  today.setDate(today.getDate() - 1);
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  today.setMilliseconds(0);
  return today;
}

export function showUntil(until: Date) {
  var now = new Date();
  now.setHours(0);
  now.setMinutes(0);
  now.setMilliseconds(0);
  return isAfter(until, now) || isEqual(until, now);
}

export function getTrainingDatesIndoor() {
  var trainingDates: string[] = [
    '19.09.2026',
    '03.10.2026',
    '17.10.2026',
    '31.10.2026',
    '14.11.2026',
    '28.11.2026',
    '12.12.2026',
  ];
  return getTrainingDates(trainingDates);
}

export function getTrainingDatesOutdoor() {
  var trainingDates: string[] = [
    '09.06.2026',
    '16.06.2026',
    '23.06.2026',
    '30.06.2026',
    '07.07.2026',
    '14.07.2026',
    '21.07.2026',
    '28.07.2026',
    '04.08.2026',
    '11.08.2026',
    '18.08.2026',
    '25.08.2026',
    '01.09.2026',
  ];
  return getTrainingDates(trainingDates);
}

export function getTrainingDates(trainingDates: string[]) {
  var result = '';

  for (var i = 0; i < trainingDates.length; i++) {
    if (
      compareAsc(
        parse(trainingDates[i], 'dd.MM.yyyy', new Date()),
        getCompareDate(),
      ) > 0
    ) {
      result += trainingDates[i];
      if (i < trainingDates.length - 1) {
        result += ', ';
      }
    }
  }

  return result;
}
